import React, { useState, useEffect, Fragment } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import logo from '../../assets/img/odu-yatay.png'
import doku from '../../assets/img/bd-doku2.png'
import { BsPrinter } from "react-icons/bs"

import getBasvuruByNo from '../../services/getBasvuruByNo'


const FormPrint = () => {



    const handlePrint = () => {
        window.print()
    }

    let { basvuruNo } = useParams()

    const [data, setData] = useState([])


    const tarihCevir = (tarih) => {
        const dateParts = tarih.split('-');
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];

        return `${day}-${month}-${year}`
    }
    const navigate = useNavigate()

    useEffect(() => {
        const fecthData = async () => {
            const result = await getBasvuruByNo(basvuruNo)
            if(!result) {
                navigate('/')
            }
            else if (result) {
                setData(result)
                document.title = result.arastirmaciAdiSoyadi + '-' + result.basvuruNo
            } 
        }
        fecthData()
        //eslint-disable-next-line
    }, []);

    return (
        <div className='relative flex justify-center items-center w-full min-h-screen pb-11' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
            <div className='mx-auto w-full max-w-4xl pt-11 print:pt-0'>

                <button className='inline-flex items-center gap-x-2 print:hidden mb-4 rounded-md px-3 py-2 bg-slate-100 hover:bg-slate-300 transition-all text-sm text-slate-500 border border-slate-300 outline-1 outline-slate-300 outline-dashed outline-offset-2' onClick={(handlePrint)}><BsPrinter /> Yazdır</button>

                <table id='basvuruTablo' className='basvuruTablo border-2 border-slate-400 mx-auto w-full text-sm' align='middle'>
                    <tbody className='divide-y divide-slate-400 bg-white'>
                        <tr>
                            <td colSpan={3} className='px-6 py-6'>
                                <div className='flex justify-between w-full'>
                                    <div className=''>
                                        <img src={logo} alt='Ordu Üniversitesi' className='h-16' />
                                        <p className='mt-3 text-lg font-semibold'>SOSYAL VE BEŞERİ BİLİMLER ARAŞTIRMALARI ETİK KURUL BAŞVURU FORMU</p>
                                    </div>
                                    <div className='flex flex-col justify-center items-end ms-auto bg-amber-200 px-3'>
                                        <p className='font-semibold text-lg'>Başvuru No</p>
                                        <p className='font-semibold text-4xl'>{data.basvuruNo}</p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 text-center font-semibold'>Araştırma Başlığı</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 leading-6'>
                                <p>{data.arastirmaBasligiTR}</p>
                                <p>{data.arastirmaBasligiEN}</p>
                            </td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 font-semibold'>Başvuru Tütü</td>
                            <td className='px-4 py-2 font-semibold'>Çalışma Dili</td>
                            <td className='px-4 py-2 font-semibold'>Çalışma Türü</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400'>{data.basvurumerkezi}</td>
                            <td className='px-4 py-2 border border-slate-400'>{data.arastirmaDili}</td>
                            <td className='px-4 py-2 border border-slate-400'>{data.calismaTuru}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 text-center font-semibold'>Sorumlu Araştırmacı Bilgileri</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Unvanı</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.arastimarciUnvani}</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Adı Soyadı</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.arastirmaciAdiSoyadi}</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Fak&uuml;lte / Y&uuml;ksekokul / Enstit&uuml;</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.arastimaciFYE}</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>B&ouml;l&uuml;m / Anabilim Dalı</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.arastimaciBolumAnabilimDali}</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Telefon</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.telefon}</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>E-Posta</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.ePosta}</td>
                        </tr>
                        <tr>
                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Adres</td>
                            <td className='px-4 py-2 border border-slate-400' colSpan={2}>{data.adres}</td>
                        </tr>
                        {
                            data.yardimciArastirmaci ? (

                                data.yardimciArastirmaci[0].map((item, key) => (
                                    <Fragment key={key}>
                                        <tr>
                                            <td colSpan={3} className='px-4 py-2 text-center font-semibold'>Yardımcı Araştırmacı</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Unvanı</td>
                                            <td colSpan={2}>{item.yrdArastimarciUnvani}</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Adı Soyadı</td>
                                            <td colSpan={2}>{item.yrdArastirmaciAdiSoyadi}</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Fak&uuml;lte / Y&uuml;ksekokul / Enstit&uuml;</td>
                                            <td colSpan={2}>{item.yrdArastimaciFYE}</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>B&ouml;l&uuml;m / Anabilim Dalı</td>
                                            <td colSpan={2}>{item.yrdArastimaciBolumAnabilimDali}</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>E-Posta</td>
                                            <td colSpan={2}>{item.yrdEPosta}</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Telefon</td>
                                            <td colSpan={2}>{item.yrdTelefon}</td>
                                        </tr>
                                        <tr>
                                            <td className='px-4 py-2 border border-slate-400 font-semibold'>Adres</td>
                                            <td colSpan={2}>{item.yrdAdres}</td>
                                        </tr>
                                    </Fragment>
                                ))
                            ) : null
                        }

                        {
                            data.koordinatorUnvani ? (
                                <>
                                    <tr>
                                        <td colSpan={3} className='px-4 py-2 text-center font-semibold'>Koordinat&ouml;r</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>Unvanı</td>
                                        <td colSpan={2}>{data.koordinatorUnvani}</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>Adı Soyadı</td>
                                        <td colSpan={2}>{data.koordinatorAdiSoyadi}</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>Fak&uuml;lte / Y&uuml;ksekokul / Enstit&uuml;</td>
                                        <td colSpan={2}>{data.koordinatorFYE}</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>B&ouml;l&uuml;m / Anabilim Dalı</td>
                                        <td colSpan={2}>{data.koordinatorBolumAnabilimDali}</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>E-Posta</td>
                                        <td colSpan={2}>{data.kooridnatorEposta}</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>Telefon</td>
                                        <td colSpan={2}>{data.koordinatorTelefon}</td>
                                    </tr>
                                    <tr>
                                        <td className='px-4 py-2 border border-slate-400 font-semibold'>Adres</td>
                                        <td colSpan={2}>{data.kooridnatorAdres}</td>
                                    </tr>
                                </>
                            ) : null
                        }

                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>1. Araştırma ile İlgili Genel Bilgiler ve Araştırmanın Amacı</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.arastirmaAmaci}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>2. Veri Toplama Aracının/Araçlarının Türü</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>
                                {
                                    data.veriToplamaAraci &&

                                    data.veriToplamaAraci.map((item, key) => (
                                        <Fragment key={key}>
                                            <span>{item}, </span>
                                        </Fragment>
                                    ))
                                    
                                }
                                <span>{data.digerveriToplamaAraci}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>3. Veri Toplanması Planlanan Dönem</td>
                        </tr>

                        {
                            data.veriToplamaDonemleri && (
                                <tr>
                                    <td colSpan={3} className='px-4 py-2'>Başlangıç : {tarihCevir(data.veriToplamaDonemleri[0].baslangicTarihi)} - Bitiş : {tarihCevir(data.veriToplamaDonemleri[0].bitisTarihi)}</td>
                                </tr>
                            )
                        }


                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>4. Veri Toplanması Planlanan Yerler/Mekanlar, Çevrimiçi Platformlar, Kurum ve Kuruluşlar</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>
                                {
                                    data.veriToplamaPlatformu && (
                                        data.veriToplamaPlatformu[0].map((item, key) => (
                                            <Fragment key={key}>
                                                <p>{item.name}</p>
                                            </Fragment>
                                        ))
                                    )
                                }
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>5. Araştırmayı hangi yöntem ya da yöntemlerle gerçekleştirmeyi planlıyorsunuz? Açıklayınız. </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.arastirmaYontemi}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>6.Çalışma grubunuzu tanımlayınız</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.calismaGurubu}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>7. Seçeceğiniz çalışma grubu için dâhil olma ve varsa dışta kalma kriterleri nelerdir? </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.calismaOlcutu}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>
                                <p>8. Kullanılacak ölçme araçlarına yönelik maddeleri açık bir şekilde başvuru formuna ekleyiniz.</p>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.olcmeAraci}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>9. Uygulama için gerekli izinleri hangi kurumlardan aldınız/almayı planlıyorsunuz? </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.uygulamaIzinKurum}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>10. Bu çalışmanın uygulama yapacağınız/veri toplayacağınız kişiler açısından olası riskleri nelerdir? Bu olası risklere karşı ne tür önlemler almayı planlıyorsunuz? </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.calismaRiskleri}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>11. Araştırmaya katılan bireylerin araştırmadan ayrılma ya da uygulamayı sonlandırma koşulları nelerdir?</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.uygulamaSonlandirmaKosullari}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>12.Çalışmada katılımcılara, herhangi bir şekilde yanlı/yanlış bilgi verilmesi ve çalışmanın amacının kısmen/tamamen gizli tutulması gerekiyor mu? </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.katilimSonrasiBilgilendirme}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>13. Araştırmada, eğer varsa, ses ve görüntü verilerinin toplanmasında kullanılacak yöntemler yürürlükteki mevzuata uygun mu? </td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>{data.medyaSaklamaKosullari}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>
                                <p>14. Referanslar (Varsa)</p>
                            </td>
                        </tr>
                        <tr >
                            <td colSpan={3} className='px-4 py-2'>{data.referanslar}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2 font-semibold'>15. Başvuru Dosyasının İ&ccedil;eriği</td>
                        </tr>
                        <tr>
                            <td colSpan={3} className='px-4 py-2'>
                                {
                                    data.basvuruDilekcesiFile && (<p>Başvuru Dilekçesi</p>)
                                }
                                {
                                    data.ozgecmisFile && (<p>Özgeçmiş</p>)
                                }
                                {
                                    data.kurulKarariFile && (<p>Enstitü/Anabilim Dalı Kurul Kararı</p>)
                                }
                                {
                                    data.veliOnamFormuFile && (<p>Veli Onam Formu</p>)
                                }
                                {
                                    data.gonulluOnamFormuFile && (<p>Gönüllü Onam Formu</p>)
                                }
                                {
                                    data.veriToplamaAraclariFile && (<p>Veri Toplama Araçları</p>)
                                }
                                {
                                    data.veriToplamaIzinYazisiFile && (<p>Veri Toplama Aracı Erişim İzin Yazısı</p>)
                                }
                                {
                                    data.veriToplamaAraclariEkFile && (<p>Veri Toplama Aracı Açık Erişim Linki ve Ekleri</p>)
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    );
}

export default FormPrint;
